/* build:1779801300 ritual cinema v7 : added gift cells + category-landing product cards */
/* LUV : auto-inject wishlist hearts on every product card.
 * Works on collection grids, homepage rails, search results, related products, PagePilot pages.
 * No template edits required. Hooks into window.wtmWishlist API.
 */
(function () {
  if (window.__luvHeartsInit) return;
  window.__luvHeartsInit = true;

  var STYLE_ID = 'luv-wl-hearts-style';
  if (!document.getElementById(STYLE_ID)) {
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = [
      '.luv-card-heart {',
      '  position: absolute; top: 10px; right: 10px; z-index: 5;',
      '  width: 36px; height: 36px; border-radius: 50%;',
      '  display: inline-flex; align-items: center; justify-content: center;',
      '  background: rgba(255,251,245,0.92); border: 0; padding: 0; cursor: pointer;',
      '  box-shadow: 0 2px 8px rgba(35,27,34,0.10);',
      '  transition: transform .15s ease, background .15s ease;',
      '  -webkit-tap-highlight-color: transparent;',
      '}',
      '.luv-card-heart:hover { transform: scale(1.06); background: #fff; }',
      '.luv-card-heart svg { width: 18px; height: 18px; display: block; }',
      '.luv-card-heart svg path { fill: none; stroke: #231B22; stroke-width: 2; transition: all .15s ease; }',
      '.luv-card-heart.is-wishlisted svg path { fill: #C9826B; stroke: #C9826B; }',
      '@media (max-width: 768px) {',
      '  .luv-card-heart { width: 34px; height: 34px; top: 8px; right: 8px; }',
      '  .luv-card-heart svg { width: 16px; height: 16px; }',
      '}',
      '/* Film product rows : keep heart at top-right (original placement). The card height is grown in the section CSS so the heart sits in clean space above the In ritual pill. */',
      '.luv-film-product { position: relative; }',
      '.luv-film-product .luv-card-heart {',
      '  position: absolute; top: 8px; right: 10px; left: auto;',
      '  width: 28px; height: 28px;',
      '  background: rgba(35,27,34,0.72);',
      '  box-shadow: 0 1px 4px rgba(0,0,0,0.25);',
      '}',
      '.luv-film-product .luv-card-heart svg { width: 14px; height: 14px; }',
      '.luv-film-product .luv-card-heart svg path { stroke: #FFFBF5; }',
      '.luv-film-product .luv-card-heart:hover { background: rgba(35,27,34,0.92); }',
      '.luv-film-product .luv-card-heart.is-wishlisted svg path { fill: #C9826B; stroke: #C9826B; }',
      '/* Heroes rail uses pill-shaped cards : heart small, slightly inset */',
      '.luv-hero .luv-card-heart { top: 8px; right: 8px; width: 32px; height: 32px; }',
      '.luv-hero .luv-card-heart svg { width: 15px; height: 15px; }',
      '/* Routine builder step cards */',
      '.luv-step-card .luv-card-heart { top: 8px; right: 8px; }',
      '/* Ritual cinema cards : how-to and deepbox steps + finale hero */',
      '.luv-howto__step .luv-card-heart, .luv-deepbox__step .luv-card-heart { top: 12px; right: 12px; width: 40px; height: 40px; }',
      '.luv-howto__step .luv-card-heart svg, .luv-deepbox__step .luv-card-heart svg { width: 20px; height: 20px; }',
      '.luv-deepbox__hero .luv-card-heart { top: 14px; right: 14px; width: 40px; height: 40px; }',
      '.luv-deepbox__hero .luv-card-heart svg { width: 20px; height: 20px; }',
      '.luv-howto__media, .luv-deepbox__media, .luv-deepbox__hero-media { position: relative; }',
      '/* ensure card host is a positioning context */',
      '.card-wrapper, .product-card-wrapper, .card, .card__inner, .grid__item .card-wrapper,',
      '.luv-top, .luv-box, .luv-film-product, .luv-shelf-card,',
      '.luv-hero, .luv-step, .luv-step-card,',
      '.luv-cr__card, .luv-cn__scent-card, .luv-sbc-tile, .luv-pdp-cross__card, .luv-gift__cell, .luv-cl-prod,',
      '.luv-heroes-rail .product-card, [class*="luv-heroes"] .product-card,',
      '.pagepilot-product-card, .product-grid-item, .product-item, .grid-product { position: relative; }'
    ].join('\n');
    document.head.appendChild(st);
  }

  var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.5-9.2C1 8.1 3.3 4.5 6.9 4.5c2 0 3.6 1.1 5.1 3 1.5-1.9 3.1-3 5.1-3 3.6 0 5.9 3.6 4.4 7.3C19.5 16.4 12 21 12 21z"/></svg>';

  // Detect a product card root: any element that contains a product link
  function findProductLinks(root) {
    return (root || document).querySelectorAll('a[href*="/products/"]');
  }

  function getProductHandleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([a-z0-9\-_]+)/i);
    return m ? m[1] : null;
  }

  // Skip these surfaces entirely : not browsing cards
  function isInSkipZone(link) {
    return !!link.closest([
      'header', '.header', 'nav', 'footer', '.footer',
      '.menu-drawer', '.wtm-wl-drawer', 'pagepilot-cart-drawer-component', '.luv-wl-drawer',
      '.breadcrumb', '.announcement-bar', '.utility-bar',
      // Big rotating offers-hero carousel : full-page promo slides, not product cards
      '.luv-offers-hero', '.luv-offers', '.slideshow', '.slider:not(.luv-heroes__rail):not(.luv-tops-rail)',
      '.cart-drawer', '#cart-drawer'
    ].join(', '));
  }

  // Find the visual card root for a product link
  function findCardRoot(link) {
    if (isInSkipZone(link)) return null;
    var candidates = [
      '.card-wrapper.product-card-wrapper',
      '.product-card-wrapper',
      '.card-wrapper',
      '.luv-top',           // top customer favourites
      '.luv-box',           // ritual boxes
      '.luv-film-product',  // ritual films product cards
      '.luv-shelf-card',    // ritual shelf cards (if used)
      // Heroes rail : "Buy two heroes" : .luv-hero is the anchor itself
      '.luv-heroes__rail .luv-hero',
      '.luv-hero.in',       // fallback : the "in" class only appears on rail cards
      // Routine builder Korean Way step cards : full step card includes meta + image
      '.luv-step-card',
      '.luv-step',
      // Ritual landing pages : cinema cards (how-to flow + deepbox flow + finale hero)
      '.luv-howto__step',
      '.luv-deepbox__step',
      '.luv-deepbox__hero',
      // Candles page : ritual cards + scent cards
      '.luv-cr__card',
      '.luv-cn__scent-card',
      // Homepage "Shop by category" tiles
      '.luv-sbc-tile',
      // PDP cross-sell cards (You may also love)
      '.luv-pdp-cross__card',
      // Homepage "gift candle" cells
      '.luv-gift__cell',
      // Category landing pages (face-ritual, body-ritual, hair-ritual) product tiles
      '.luv-cl-prod',
      '.product-card',
      '.product-grid-item',
      '.grid-product',
      '.product-item'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var c = link.closest(candidates[i]);
      if (c) return c;
    }
    return null;
  }

  // Cache: handle -> product id (resolved via /products/handle.js)
  window.__luvHandleToId = window.__luvHandleToId || {};
  var pendingFetches = {}; // handle -> Promise

  function resolveProductId(handle) {
    if (!handle) return Promise.resolve(null);
    if (window.__luvHandleToId[handle]) return Promise.resolve(window.__luvHandleToId[handle]);
    if (pendingFetches[handle]) return pendingFetches[handle];
    pendingFetches[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.id) {
          window.__luvHandleToId[handle] = String(p.id);
          // Cache full product for drawer use
          window.__wtmProductCache = window.__wtmProductCache || {};
          window.__wtmProductCache[String(p.id)] = p;
          return String(p.id);
        }
        return null;
      })
      .catch(function () { return null; })
      .finally(function () { delete pendingFetches[handle]; });
    return pendingFetches[handle];
  }

  function findImageHost(card) {
    // For film-product rows, attach heart to the card itself so it floats at top-right above the In ritual pill
    if (card.classList && card.classList.contains('luv-film-product')) {
      return card;
    }
    // Prefer the image / media wrapper to anchor the heart
    return card.querySelector('.luv-howto__media, .luv-deepbox__media, .luv-deepbox__hero-media, .luv-pdp-cross__card-media, .luv-cr__card-media, .luv-cn__scent-media, .luv-sbc-tile-media, .luv-gift__cell-img, .luv-gift__cell-media, .luv-cl-prod-img, .luv-cl-prod-media, .card__media, .card__inner, .media, .product-card__image, .product-card-media, .card__content') || card;
  }

  function makeHeart(pid, handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'luv-card-heart js-wtm-wishlist';
    btn.setAttribute('data-wtm-heart', '');
    btn.setAttribute('data-product-id', pid);
    btn.setAttribute('data-product-handle', handle || '');
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = HEART_SVG;
    if (window.wtmWishlist && window.wtmWishlist.has(pid)) {
      btn.classList.add('is-wishlisted');
      btn.setAttribute('aria-pressed', 'true');
    }
    return btn;
  }

  function ensureHeartOnCard(card, link) {
    if (!card || card.__luvHeartProcessed) return;
    // Skip if a heart already exists (could be from another source)
    if (card.querySelector('.luv-card-heart, [data-wtm-heart]')) {
      card.__luvHeartProcessed = true;
      return;
    }
    var handle = getProductHandleFromHref(link.getAttribute('href'));
    if (!handle) return;
    card.__luvHeartProcessed = true;

    var host = findImageHost(card);
    // Guard: <img> is a void element and cannot contain children. If the matched host is an IMG, fall back to the card itself.
    if (host && host.tagName === 'IMG') host = card;
    // Make sure host is positioning context
    var cs = getComputedStyle(host);
    if (cs.position === 'static') host.style.position = 'relative';
    // Also ensure the card itself is positioning
    var csCard = getComputedStyle(card);
    if (csCard.position === 'static') card.style.position = 'relative';

    // Add handle on card for drawer fallback lookup
    if (!card.hasAttribute('data-product-handle')) card.setAttribute('data-product-handle', handle);

    // Resolve product id then inject the heart
    resolveProductId(handle).then(function (pid) {
      if (!pid) { card.__luvHeartProcessed = false; return; }
      // Double-check no heart was added meanwhile
      if (card.querySelector('.luv-card-heart, [data-wtm-heart]')) return;
      card.setAttribute('data-product-id', pid);
      var heart = makeHeart(pid, handle);
      host.appendChild(heart);
    });
  }

  function scanAndAttach(root) {
    var links = findProductLinks(root);
    var seenCards = new Set();
    links.forEach(function (link) {
      var card = findCardRoot(link);
      if (!card || seenCards.has(card)) return;
      seenCards.add(card);
      ensureHeartOnCard(card, link);
    });
  }

  function init() {
    scanAndAttach(document);
    // Observe future cards (filters, infinite scroll, PagePilot dynamic loads)
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function (mutations) {
        // Cheap dedupe: schedule one scan per tick
        if (pending) return;
        var hasAdd = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length; });
        if (!hasAdd) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          scanAndAttach(document);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Safety re-scan after lazy content arrives
  setTimeout(function () { scanAndAttach(document); }, 1500);
  setTimeout(function () { scanAndAttach(document); }, 4000);
})();
